module.exports = __webpack_public_path__ + "static/img/newsBanner.4a6b0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newsBanner.png
// module id = tv5k
// module chunks = 1